





































import { Component, Vue, Watch } from 'vue-property-decorator';
import VirtualMachineHardware from '@/components/virtual-machine-edit/VirtualMachineHardware.vue';
import VirtualMachineSnapshot from '@/components/virtual-machine-edit/VirtualMachineSnapshot.vue';
import VirtualMachineNetworks from '@/components/virtual-machine-edit/VirtualMachineNetworks.vue';
import Logs from '@/components/common/Logs.vue';

@Component({
  props: ['virtualMachine'],
  components: {
    VirtualMachineHardware,
    VirtualMachineSnapshot,
    VirtualMachineNetworks,
    Logs,
  },
})
export default class VirtualMachineStats extends Vue {
  isTabActive = 0;
  virtualMachineId = 0;
  @Watch('$props.virtualMachine', { immediate: true, deep: true })
  onVirtualMachineData(data: any) {
    if (data && data.id) {
      this.virtualMachineId = data.id;
    }
  }

  mounted() {
    this.isTabActive = parseInt(this.$route.params.tabId || '0', 10);
    if (this.isTabActive < 0 || this.isTabActive > 4) {
      this.isTabActive = 0;
    }
  }

  tabSelected(index: number) {
    this.isTabActive = index;
    setTimeout(() => {
      window.scrollTo(0, document.body.scrollHeight);
    }, 500);
  }
}
